// Build metadata injected at bundle time by Vite define() in `frontend/vite.config.js`.
// These constants are intentionally global so they can be read anywhere (including settings/support flows).

// eslint-disable-next-line no-undef
export const buildId = typeof __GMER_BUILD_ID__ !== 'undefined' ? __GMER_BUILD_ID__ : 'unknown';
// eslint-disable-next-line no-undef
export const buildTime = typeof __GMER_BUILD_TIME__ !== 'undefined' ? __GMER_BUILD_TIME__ : null;

export const getBuildLabel = () => {
  const timePart = buildTime ? String(buildTime).replace(/[-:.TZ]/g, '').slice(0, 12) : 'unknown';
  return `${buildId}${buildTime ? ` (${timePart})` : ''}`;
};
